import './VariableChart.scss';
import Component from './VariableChart';
export default Component;